<template>
  <div class="button--sosmed">
    <a
      target="_blank"
      rel="noopener noreferrer"
      :href="`https://www.facebook.com/sharer.php?u=${windowURL}`"
      title="facebook"
      class="icon icon--fb"
    >
      <SvgImg id="btn-fb" name="btn-fb" width="10" height="16" />
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer"
      :href="`https://twitter.com/intent/tweet?text=Review ${manufactureName} - ${productName} - ${windowURL}`"
      title="twitter"
      class="icon icon--twitter"
    >
      <SvgImg id="btn-twitter" name="btn-twitter" width="16" height="14" />
    </a>
    <a
      :href="`https://api.whatsapp.com/send?text=Review ${manufactureName} - ${productName} - ${windowURL}`"
      target="_blank"
      rel="noopener noreferrer"
      title="whatsapp"
      class="icon icon--whatsapp"
    >
      <SvgImg id="btn-whatsapp" name="btn-whatsapp" width="16" height="16" />
    </a>
    <a
      :href="`mailto:?subject=Sociolla%20Review&&body=${product.brand.name} ${product.name} - ${windowURL}`"
      title="mail"
      class="icon icon--mail"
    >
      <SvgImg id="btn-mail" name="btn-mail" width="16" height="12" />
    </a>
    <a href="#" title="share" class="icon icon--share" @click.prevent="doCopy">
      <SvgImg id="btn-share" name="btn-share" width="15" height="15" />
    </a>
  </div>
</template>
<script>
/* eslint-disable vue/require-prop-types */
export default {
  name: 'share-sosmed-product',
  props: {
    product: {
      required: true,
    },
  },
  computed: {
    reviewSite() {
      return this.$store.state.REVIEW_WEB_URL;
    },
    windowURL() {
      return encodeURI(window.location.href);
    },
    manufactureName() {
      return this.product.manufacture && this.product.manufacture.name ? this.product.manufacture.name : '';
    },
    productName() {
      return this.product.name ? this.product.name : '';
    },
  },
  methods: {
    doCopy() {
      this.$copyText(this.windowURL).then(
        (e) => {
          this.$toasted.global.show('Link copied');
        },
        function (e) {
          this.$toasted.global.show('Can not copy the link');
        }
      );
    },
  },
};
</script>
